import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  CreateFormSectionDto,
  FormSectionDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_FORM_SECTIONS_CONFIG } from "../domain";

import { formsSectionsConfigApi } from "@api/services";
import { ACTION_GET_FORM_SECTIONS, DOMAIN_FORMS, roleGuard } from "@api";

const ACTION_CREATE_FORM_SECTION_CONFIG = "CREATE_FORM_SECTION_CONFIG";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const createFormSectionConfig = async (
  props: CreateFormSectionDto,
): Promise<FormSectionDto> => {
  const response =
    await formsSectionsConfigApi.formSectionsConfigControllerCreateFormSectionConfig(
      props,
    );

  return response.data;
};

export const useCreateFormSectionConfig = (
  user: UserProfileDto | null,
  formId: string,
): {
  createFormSectionConfig: UseMutateFunction<
    FormSectionDto,
    Error,
    CreateFormSectionDto,
    unknown
  >;
  createFormSectionConfigEnabled: boolean;
  isSuccessCreateFormSectionConfig: boolean;
  isPendingCreateFormSectionConfig: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_FORM_SECTIONS_CONFIG, ACTION_CREATE_FORM_SECTION_CONFIG],
    mutationFn: enabled ? createFormSectionConfig : undefined,
    onSuccess(data) {
      const queryKey = [DOMAIN_FORMS, ACTION_GET_FORM_SECTIONS, formId];
      const currentData = queryClient.getQueryData<FormSectionDto[] | undefined>(
        queryKey,
      );

      queryClient.setQueryData(queryKey, () => {
        return currentData ? [...currentData, data] : [data];
      });
    },
  });

  return {
    createFormSectionConfig: mutate,
    createFormSectionConfigEnabled: enabled,
    isSuccessCreateFormSectionConfig: isSuccess,
    isPendingCreateFormSectionConfig: isPending,
  };
};
